import { lazy } from 'react';
import { IRouteProps } from 'src/modules';

export const route = '/explore-collections';

const AccountsRoute: IRouteProps = {
    path: route,
    exact: true,
    component: lazy(() => import('./Collections.list')),
    name: 'CollectionList',
};

export default AccountsRoute;
